import React from 'react'
import { DepositBankAccount } from 'types/BankAccountsDetails'
import { BankTransferType } from 'types/beneficiaries'
import { Currencies, WalletType } from 'types/types'
import LocalDetails from './LocalDetails'
import SwiftDetails from './SwiftDetails'

interface SingleDepositDetailsProps {
  account: DepositBankAccount
  wallet: WalletType
}

const SingleDepositDetails = ({ account, wallet }: SingleDepositDetailsProps) => {
  return (
    <>
      {account?.isSwift || account?.accountNumberFormat === BankTransferType.SWIFT ? (
        <SwiftDetails options={account} />
      ) : (
        <LocalDetails
          currency={wallet?.currency?.code as Currencies}
          options={account}
          wallet={wallet}
          isSegregated
        />
      )}
    </>
  )
}

export default SingleDepositDetails
